import React from "react";
import styles from "./dapps.module.scss";
import constants from "../constants/apps.constants";
import AppsCard from "../components/Cards/AppsCard";
const DApps = () => {
  return (
    <div className={styles.root}>
      <section className={styles.top}>
        <span className={styles.title}>dVPN Apps</span>
        <span className={styles.description}>
          Stay protected online using a dVPN Application built on Sentinel.
        </span>
      </section>
      <section className={styles.bottom}>
        {constants.map((c, i) => {
          return <AppsCard key={`dvpn-app-${i}`} data={c} />;
        })}
      </section>
    </div>
  );
};

export default DApps;
